import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { KNTrailerIcon, KNTruckIcon } from 'components/KNIcon/KNIcon'
import { Role } from 'context/authentication/Role.types'
import { hasAccess } from 'global/helpers/authorization'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { VehicleType } from 'screens/VehicleManager/VehicleManager.types'
import type { TripData } from './TripDashboard.types'
import VehicleAssignmentField from './VehicleAssignmentField'

export interface VehicleAssignmentProps {
  trip: TripData
  onChange?: (updatedTrip: TripData, action?: string) => void
}

const VehicleAssignment = ({
  trip,
  onChange,
}: VehicleAssignmentProps): ReactNode => {
  const { t } = useTranslation()

  if (hasAccess(Role.Editor)) {
    return (
      <Stack spacing={0.5} direction="column">
        {!trip.assignedTruck && !trip.assignedTrailer && (
          <VehicleAssignmentField trip={trip} onChange={onChange} />
        )}
        {(trip.assignedTruck || (trip.assignedTrailer && !trip.assignedTruck)) && (
          <VehicleAssignmentField trip={trip} vehicleType={VehicleType.TRUCK} onChange={onChange} />
        )}
        {(trip.assignedTrailer || (trip.assignedTruck && !trip.assignedTrailer)) && (
          <VehicleAssignmentField trip={trip} vehicleType={VehicleType.TRAILER} onChange={onChange} />
        )}
      </Stack>
    )
  }

  if (trip.assignedTruck || trip.assignedTrailer) {
    return (
      <Stack spacing={0.5} direction="column">
        {trip.assignedTrailer && (
          <Stack direction="row" spacing={0.5} alignItems="center">
            <KNTrailerIcon sx={{ color: 'primary.light', width: '16px', height: '16px' }} />
            <Typography component="p" variant="p3" color="primary.main" noWrap>
              {trip.assignedTrailer.licensePlate}
            </Typography>
          </Stack>
        )}
        {trip.assignedTruck && (
          <Stack direction="row" spacing={0.5} alignItems="center">
            <KNTruckIcon sx={{ color: 'primary.light', width: '16px', height: '16px' }} />
            <Typography component="p" variant="p3" color="primary.main" noWrap>
              {trip.assignedTruck.licensePlate}
            </Typography>
          </Stack>
        )}
      </Stack>
    )
  }

  return (
    <Typography component="p" variant="p3" color="primary.light" noWrap>
      {t('screens.cs.trip_dashboard.card.not_assigned')}
    </Typography>
  )
}

export default VehicleAssignment
